import { ChangeDetectionStrategy, Component } from "@angular/core";

/**
 * Composant Conversations dans le drawer
 * Pattern list ↔ thread avec navigation entre les vues
 */
@Component({
  selector: "app-drawer-conversations",
  templateUrl: "./drawer-conversations.component.html",
  styleUrls: ["./drawer-conversations.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerConversationsComponent {
  viewMode: "list" | "thread" = "list";
  currentConversationId: string | null = null;
  activeTab: "ongoing" | "archived" = "ongoing";

  openConversation(conversationId: string) {
    this.currentConversationId = conversationId;
    this.viewMode = "thread";
  }

  backToList() {
    this.viewMode = "list";
    this.currentConversationId = null;
  }

  onCreateConversation() {
    // TODO: Implémenter la création de conversation
  }

  onTabChange(tab: string) {
    this.activeTab = tab as "ongoing" | "archived";
  }

  /** Réinitialise la vue à la liste (appelé par le parent quand on quitte l'onglet) */
  resetView(): void {
    this.viewMode = "list";
    this.currentConversationId = null;
  }
}
